import { memo } from "react";
import { cn } from "@/lib/utils";
import { useTranslation } from "@/hooks/useTranslation";

interface LoginTabsProps {
  onGoToRegister: () => void;
}

export const LoginTabs = memo(function LoginTabs({ onGoToRegister }: LoginTabsProps) {
  const { t } = useTranslation();

  return (
    <div className="flex border-b border-border bg-white dark:bg-card rounded-t-lg overflow-hidden">
      <button
        type="button"
        className={cn(
          "flex-1 py-3 px-6 text-center font-medium text-sm transition-colors",
          "border-b-2 border-pink-500 text-pink-600 font-semibold bg-white dark:bg-card"
        )}
      >
        {t('auth.signIn')}
      </button>
      <button
        type="button"
        onClick={onGoToRegister}
        className={cn(
          "flex-1 py-3 px-6 text-center font-medium text-sm transition-colors",
          "border-b-2 border-transparent text-muted-foreground hover:text-foreground"
        )}
      >
        {t('auth.signUp')}
      </button>
    </div>
  );
});

